import type { TextareaHTMLAttributes } from "react";

type TextareaProps = Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, "className"> & {
  className?: string | undefined;
  error?: string | undefined;
};

export function Textarea({ className, error, id, ...props }: TextareaProps): JSX.Element {
  const errorId = id === undefined ? undefined : `${id}-error`;
  return (
    <div className="w-full">
      <textarea
        id={id}
        aria-invalid={error !== undefined}
        aria-describedby={errorId}
        className={cx(base, error !== undefined && "border-danger focus:border-danger", className)}
        {...props}
      />
      {error !== undefined && (
        <p id={errorId} className="mt-1 text-xs text-danger">
          {error}
        </p>
      )}
    </div>
  );
}

const base =
  "min-h-28 w-full rounded-md border border-border bg-surface px-3 py-2 text-sm text-text-primary placeholder:text-text-tertiary shadow-soft transition focus:border-primary focus:outline-none focus:ring-2 focus:ring-[var(--color-focus-ring)] disabled:cursor-not-allowed disabled:opacity-60";

function cx(...classes: Array<string | false | undefined>): string {
  return classes.filter(Boolean).join(" ");
}
